"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleBase = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = require("../style/colors");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var rotationAnimation = (0, _styledComponents.keyframes)(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);

var StyleBase = _styledComponents["default"].div.withConfig({
  displayName: "StyleBase",
  componentId: "sc-16x5ab7-0"
})(["svg{animation:", " 1.2s cubic-bezier(0.5,0,0.5,1) infinite;#fill-spinner{fill:", ";}}"], rotationAnimation, function (_ref) {
  var color = _ref.color;
  return color || _colors.primary;
});

exports.StyleBase = StyleBase;